/* eslint-disable no-unused-vars */
import { post } from "jquery";
import { Delete, Get, Post, PostFormData, Put, PutFormData } from "../Request";

export default {
  state: {
    videosList: [],
    videosCategory: [],
  },
  getters: {
    GetVideosList(state) {
      return state.videosList;
    },
    GetVideosCategory(state) {
      return state.videosCategory;
    },
  },
  actions: {
    async SetVideoVisibility({ commit }, payload) {
      return PostFormData(`Video/ToggleVideoVisibility?Id=${payload}`).then((res) => {
        return res.data;
      });
    },
    async CreateVideo({ commit }, payload) {
      return await PostFormData("Video/AddVideo", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GetVideosList({ commit }, payload) {
      return await Get(
        `Video/GetAllVideos?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.categories}`
      ).then((res) => {
        commit("SetVideosList", res.data.Data.List);

        return res.data;
      });
    },
    async UpdateVideosList({ commit }, payload) {
      return await PutFormData("Video/EditVideo", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async SortVideoCategory({ commit }, payload) {
      return await Put(`Video/SortVideoCategory?sortNum=${payload.sortNum}&Id=${payload.Id}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async DeleteVideo({ commit }, payload) {
      return await Delete(
        `Video/RemoveVideo/?id=${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async GetVideosCategory({ commit }, payload) {
        return await Get("Video/GetVideoCategory").then((res) => {
          commit("SetVideosCategory", res.data.Data);
  
          return res.data;
        });
      },
      async UpdateVideoCategory({ commit }, payload) {
        return await Put("Video/EditVideoCategory", payload).then((res) => {
          return res.data;
        });
      },
      async DeleteVideoCategory({ commit }, payload) {
        return await Delete(`Video/RemoveVideoCategory?Id=${payload}`).then(
          (res) => {
            return res.data;
          }
        );
      },
    async CreateVideosCategory({ commit }, payload) {
      return await Post(
        "Video/AddVideoCategory",
        payload
      ).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetVideosList(state, payload) {
      state.videosList = payload;
    },
    SetVideosCategory(state, payload) {
      payload.sort((a, b) => a.SortBy - b.SortBy);
      state.videosCategory = payload;
    },
  },
};
